import {
  applicationStatusRegistered,
  applicationStatusRejected,
  applicationStatusPending,
  applicationStatusApproved,
  applicationStatusPublished,
  applicationStatusDeactivated
} from '@developer/svg';

export const APPLICATION_REGISTERED = 'APPLICATION_REGISTERED',
  APPLICATION_REJECTED = 'APPLICATION_REJECTED',
  APPLICATION_APPROVED = 'APPLICATION_APPROVED',
  APPLICATION_ACTIVE = 'APPLICATION_ACTIVE',
  APPLICATION_PENDING = 'APPLICATION_PENDING',
  APPLICATION_DEACTIVATED = 'APPLICATION_DEACTIVATED',
  APPLICATION_PUBLISHED = 'APPLICATION_PUBLISHED',
  APPLICATION_UNDER_REVIEW = 'APPLICATION_UNDER_REVIEW',
  appStatuses = {
    CREATED: {
      title: 'Created',
      img: applicationStatusRegistered,
    },
    REGISTERED: {
      title: 'Registered',
      img: applicationStatusRegistered,
    },
    PENDING: {
      title: 'Pending',
      img: applicationStatusPending,
    },
    DEACTIVATED: {
      title: 'Deactivated',
      img: applicationStatusDeactivated,
    },
    UNDER_REVIEW: {
      title: 'Pending',
      img: applicationStatusPending,
    },
    REJECTED: {
      title: 'Rejected',
      img: applicationStatusRejected,
    },
    PUBLISHED: {
      title: 'Published',
      img: applicationStatusPublished,
    },
    APPROVED: {
      title: 'Approved',
      img: applicationStatusApproved,
    },
    ACTIVE: {
      title: 'Active',
      img: applicationStatusApproved,
    },
    READYTOPUBLISH: {
      title: 'Readytopublish',
      img: applicationStatusRegistered,
    },
  };
